import useFetch from '../../../hooks/useFetch';
import chauffeurApi from '../chauffeurApi';

export default function useAffecterChauffeurApi() {
    return useFetch(chauffeurApi.affecter);
}
